import styles from "./table.module.less";

export type TTableProps = {
  columns: Array<string>;
  data: Array<Record<string, string>>;
};

const Table = ({ columns, data }: TTableProps) => {
  return (
    <div>
      <table className={`${styles.table}`}>
        <thead className={styles.tableHead}>
          <tr>
            {columns.map((col, index) => {
              return (
                <td
                  key={col + "-" + index}
                  className={`${styles.cell} ${index > 0 ? styles.alignRight : ""} body-base bold`}
                >
                  {col}
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            return (
              <tr className={styles.row}>
                {Object.entries(row).map(([column, value], index) => {
                  return (
                    <td key={index + "-" + value} className={`${styles.cell} ${index > 0 ? styles.alignRight : ""}`}>
                      <span className={styles.columnLabel}>{column}</span>
                      <span>{value}</span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
export { Table };
